
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/couverture-reseau",
      function () {
        return require("private-next-pages/couverture-reseau.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/couverture-reseau"])
      });
    }
  